export const zIndex = {
  pagination: 0,
  header: 0,
  dropdown: 1000,
  drawer: 1100,
} as const;

export type ZIndexToken = keyof typeof zIndex;


